export interface V2TimConversationListFilter {
    conversationType?: number;
    nextSeq?: number;
    count?: number;
    markType?: number;
    groupName?: string;
}
